<template>
    <div>
        <v-container>
            <v-overlay :value="isLoading">
                <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
            </v-overlay>
            <!-- ============================================= -->
            <h2>{{ dbDevice.name }}</h2>
            <v-divider class="mb-3"></v-divider>
            <!-- ============================================= -->
            <v-row>
                <v-col cols="7">
                    <v-menu v-model="dispCalender" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined dense v-model="targetDate" readonly v-bind="attrs" v-on="on" background-color="white"></v-text-field>
                        </template>
                        <v-date-picker v-model="targetDate" @input="dispCalender = false" locale="ja" :max="maxDate" @change="chartReload()"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="4">
                    <v-select outlined dense v-model="daySpanValue" :items="daySpanOptions" @change="chartReload()" background-color="white"></v-select>
                </v-col>
            </v-row>
            <!-- ################# 給餌量 ##################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">給餌量(kg)</h4></v-card-title>
                <div class="white chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-feed :chartDataChild="chartDataSetFeed" :yRange="chartRange.feed" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xyFeed)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################# 自発回数 ##################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="dbFeeder && dbFeeder.is_react">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">自発回数</h4></v-card-title>
                <div class="white chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-feed :chartDataChild="chartDataSetReact" :yRange="chartRange.react" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xyReact)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################# 水温 ##################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="dbSensor && (dbSensor.is_temp || dbSensor.is_water)">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">気温/水温 (℃)</h4></v-card-title>
                <div class="white chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-water :chartDataChild="chartDataSetTemp" :yRange="chartRange.temp" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xyWaterTemp)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################## 日射量 ################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="dbSensor && dbSensor.is_solar">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">日射量 (W/㎡)</h4></v-card-title>
                <div class="chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-solar :chartDataChild="chartDataSetSolar" :yRange="chartRange.solar" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xySolar)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################## DO ################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="dbSensor && dbSensor.is_oxygen">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">DO (mg/L)</h4></v-card-title>
                <div class="chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-oxygen :chartDataChild="chartDataSetOxygen" :yRange="chartRange.oxygen" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xyOxygen)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################## 塩分 #################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="dbSensor && dbSensor.is_salinity">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">塩分</h4></v-card-title>
                <div class="chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-salinity :chartDataChild="chartDataSetSalinity" :yRange="chartRange.salinity" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xySalinity)">CSV</v-btn>
                </div>
            </v-card>
            <div class="ma-5"></div>
            <!-- ################# バッテリー ##################################### -->
            <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">バッテリー(V)</h4></v-card-title>
                <div class="chart-container" style="position: relative; width: 100%; height: auto; overflow: hidden">
                    <comp-chart-battery :chartDataChild="chartDataSetBattery" :yRange="chartRange.battery" style="height: 60vh" />
                </div>
                <div class="text-right">
                    <v-btn color="success" class="ma-3" @click="downloadCSV(csvData.xyBattery)">CSV</v-btn>
                </div>
            </v-card>
            <!-- ###################################################### -->
        </v-container>
    </div>
</template>

<style></style>

<script>
import CompChartFeed from "@/components/CompChartFeed";
import CompChartWater from "@/components/CompChartWater";
import CompChartSolar from "@/components/CompChartSolar";
import CompChartOxygen from "@/components/CompChartOxygen";
import CompChartSalinity from "@/components/CompChartSalinity";
import CompChartBattery from "@/components/CompChartBattery";

export default {
    name: "DeviceChart",
    components: {
        CompChartFeed,
        CompChartWater,
        CompChartSolar,
        CompChartOxygen,
        CompChartSalinity,
        CompChartBattery,
    },
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            device_id: undefined,
            feeder_id: undefined,
            sensor_id: undefined,
            dbDevice: {},
            dbFeeder: null,
            dbSensor: null,
            dbCmd04Logs: [],
            dbCmd05Logs: [],
            dbCmd06Logs: [],
            dbCmd10Logs: [],
            windowWidth: window.innerWidth, // 画面サイズ
            windowHeight: window.innerHeight, //画面サイズ
            dispCalender: false,
            targetDate: this.$moment().format("YYYY-MM-DD"), //targetDate: "2020-08-21",
            maxDate: this.$moment().format("YYYY-MM-DD"),

            chartColor: {
                feed: "brown", //"#87ceeb", // skyblue
                react: "green", //"#87ceeb", // skyblue
                water: "skyblue", //"#87ceeb", // skyblue
                temp: "lightgreen", //"#87ceeb", // skyblue
                solar: "orange",
                oxygen: "#a3a3ff", //"#ffa500" //orange
                salinity: "#a0a0a0", //"#808080", //gray
                battery: "orange",
            },
            chartRange: {
                feed: { min: 0, max: null },
                react: { min: 0, max: null },
                temp: { min: 0, max: null },
                solar: { min: 0, max: null },
                oxygen: { min: 0, max: null },
                salinity: { min: 0, max: null },
                battery: { min: 0, max: null },
            },
            daySpanValue: 1,
            daySpanOptions: [
                { text: "1日間", value: 1 },
                { text: "2日間", value: 2 },
                { text: "7日間", value: 7 },
                { text: "14日間", value: 14 },
                { text: "30日間", value: 30 },
            ],
            dbData: {
                xyFeed: [],
                xyReact: [],
                xyWater: [],
                xyTemp: [],
                xySolar: [],
                xySalinity: [],
                xyOxygen: [],
                xyBattery: [],
            },
            csvData: {
                xyFeed: [],
                xyReact: [],
                xyWaterTemp: [],
                xySolar: [],
                xySalinity: [],
                xyOxygen: [],
                xyBattery: [],
            },
            //---------------------------
            chartDataSetFeed: { datasets: [] },
            chartDataSetReact: { datasets: [] },
            chartDataSetTemp: { datasets: [] },
            chartDataSetSolar: { datasets: [] },
            chartDataSetOxygen: { datasets: [] },
            chartDataSetSalinity: { datasets: [] },
            chartDataSetBattery: { datasets: [] },
            //---------------------------
            isLoading: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //---------------------------------------------
        this.device_id = this.$route.params.device_id;
        if (this.$route.query.targetDate) this.targetDate = this.$route.query.targetDate;
        //---------------------------------------------
        this.isLoading = true;
        await this.localRangeUpdate();
        await this.getDevices();
        await this.getFeeders();
        await this.getSensors();
        await this.getSensorData();
        this.isLoading = false;
        window.scrollTo(0, 0);
    },
    //========================================================
    computed: {},
    //========================================================
    mounted: function () {
        window.addEventListener("resize", this.handleResize);
    },
    //====================================================
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },
    //========================================================
    methods: {
        //====================================================
        handleResize: function () {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        //====================================================
        chartHeight() {
            let h = Math.floor(this.windowHeight / 3);
            if (h < 280) h = 280;
            if (this.windowWidth < 500) h = 700; //スマホ縦表示は700px
            //return h + "px";
            return "auto";
        },
        //====================================================
        async chartReload() {
            if (this.myInfo.exp < this.$moment().unix()) this.$router.push({ name: "Login" });
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 500));
            await this.getSensorData();
            this.isLoading = false;
        },
        //====================================================
        async getDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    id: this.device_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevice = response.data.json[0];
                this.feeder_id = this.dbDevice["feeder_id"];
                this.sensor_id = this.dbDevice["sensor_id"];
            });
        },
        //====================================================
        async getFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: {
                    id: this.feeder_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeder = response.data.json[0];
            });
        },
        //====================================================
        async getSensors() {
            await this.axios({
                method: "GET",
                url: "/web/api/sensors",
                params: {
                    id: this.sensor_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensor = response.data.json[0];
            });
        },
        //====================================================
        async getSensorData() {
            //--------------------------------
            let sdays = (this.daySpanValue - 1) * -1;
            const sdate = this.$moment(this.targetDate).add(sdays, "days").format("YYYY-MM-DD");
            const edate = this.$moment(this.targetDate).add(1, "days").format("YYYY-MM-DD");
            //-----------------------
            //非同期でAxiosGet
            const promise04 = this.getCmd04Logs(sdate, edate);
            const promise05 = this.getCmd05Logs(sdate, edate);
            const promise06 = this.getCmd06Logs(sdate, edate);
            //-----------------------
            //上記の終了を待つ
            await promise04;
            await promise05;
            await promise06;
            //-----------------------
            //上記が全て取得終了したタイミングで、配列マージする
            await new Promise((r) => setTimeout(r, 100));
            this.registXYdata(sdate, edate);
            this.registChartData();
            //-----------------------
        },
        //====================================================
        async localRangeUpdate() {
            if (this.$localStorage.get("chart.range.json") != undefined) {
                let localRange = JSON.parse(this.$localStorage.get("chart.range.json"));

                if (localRange["feed"]["min"]) this.chartRange.feed.min = Number(localRange["feed"]["min"]);
                if (localRange["feed"]["max"]) this.chartRange.feed.max = Number(localRange["feed"]["max"]);

                if (localRange["react"]["min"]) this.chartRange.react.min = Number(localRange["react"]["min"]);
                if (localRange["react"]["max"]) this.chartRange.react.max = Number(localRange["react"]["max"]);

                if (localRange["temp"]["min"]) this.chartRange.temp.min = Number(localRange["temp"]["min"]);
                if (localRange["temp"]["max"]) this.chartRange.temp.max = Number(localRange["temp"]["max"]);
                if (localRange["solar"]["min"]) this.chartRange.solar.min = Number(localRange["solar"]["min"]);
                if (localRange["solar"]["max"]) this.chartRange.solar.max = Number(localRange["solar"]["max"]);
                if (localRange["oxygen"]["min"]) this.chartRange.oxygen.min = Number(localRange["oxygen"]["min"]);
                if (localRange["oxygen"]["max"]) this.chartRange.oxygen.max = Number(localRange["oxygen"]["max"]);
                if (localRange["salinity"]["min"]) this.chartRange.salinity.min = Number(localRange["salinity"]["min"]);
                if (localRange["salinity"]["max"]) this.chartRange.salinity.max = Number(localRange["salinity"]["max"]);
                if (localRange["battery"]["min"]) this.chartRange.battery.min = Number(localRange["battery"]["min"]);
                if (localRange["battery"]["max"]) this.chartRange.battery.max = Number(localRange["battery"]["max"]);
            }
        },
        //====================================================
        async getCmd04Logs(sdate, edate) {
            const params = {
                device_id: this.device_id,
                "send_at[EQGREAT]": sdate,
                "send_at[SMALL]": edate,
                "_order[id]": "asc",
                _fields: "id,device_id,send_at,water,temp,solar,oxygen,salinity",
            };
            await this.axios({
                method: "GET",
                url: "/web/api/cmd04logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: params,
                timeout: 30000,
            }).then((response) => {
                this.dbCmd04Logs = response.data.json;
            });
        },
        //====================================================
        async getCmd05Logs(sdate, edate) {
            const params = {
                device_id: this.device_id,
                "send_at[EQGREAT]": sdate,
                "send_at[SMALL]": edate,
                "_order[id]": "asc",
                _fields: "id,device_id,send_at,battery_volt",
            };
            await this.axios({
                method: "GET",
                url: "/web/api/cmd05logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: params,
                timeout: 30000,
            }).then((response) => {
                this.dbCmd05Logs = response.data.json;
            });
        },
        //====================================================
        async getCmd06Logs(sdate, edate) {
            const params = {
                device_id: this.device_id,
                "feed_at[EQGREAT]": sdate,
                "feed_at[SMALL]": edate,
                "_order[id]": "asc",
                _fields: "id,device_id,feed_at,feed_weight,feed_react",
            };
            await this.axios({
                method: "GET",
                url: "/web/api/cmd06logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: params,
                timeout: 30000,
            }).then((response) => {
                this.dbCmd06Logs = response.data.json;
            });
        },
        //====================================================
        registXYdata(sdate, edate) {
            const defaultSPoint = [{ x: sdate, y: null }];
            const defaultEPoint = { x: edate, y: null };
            this.dbData.xyFeed = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xyReact = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xyWater = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xyTemp = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xySolar = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xyOxygen = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xySalinity = JSON.parse(JSON.stringify(defaultSPoint));
            this.dbData.xyBattery = JSON.parse(JSON.stringify(defaultSPoint));
            this.csvData.xyFeed = [["日時", "給餌量"]];
            this.csvData.xyReact = [["日時", "自発回数"]];
            this.csvData.xyWaterTemp = [["日時", "水温", "気温"]];
            this.csvData.xySolar = [["日時", "日射量"]];
            this.csvData.xyOxygen = [["日時", "DO"]];
            this.csvData.xySalinity = [["日時", "塩分"]];
            this.csvData.xyBattery = [["日時", "バッテリ電圧"]];
            //---------------------------------
            for (let i in this.dbCmd06Logs) {
                let x = this.dbCmd06Logs[i]["feed_at"];
                x = this.$moment(x).format("YYYY-MM-DD HH:mm:ss");
                let y = this.dbCmd06Logs[i]["feed_weight"];
                if (y != null && !isNaN(y)) y = Number(y);
                y = Math.floor(y * 1000) / 1000;
                this.dbData.xyFeed.push({ x: x, y: y });
                //this.csvData.xyFeed.push([x, y]);
                //----------
                y = this.dbCmd06Logs[i]["feed_react"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xyReact.push({ x: x, y: y });
                //this.csvData.xyReact.push([x, y]);
            }
            //---------------------------------
            for (let i in this.dbCmd05Logs) {
                let x = this.dbCmd05Logs[i]["send_at"];
                x = this.$moment(x).format("YYYY-MM-DD HH:mm:ss");
                let y = this.dbCmd05Logs[i]["battery_volt"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xyBattery.push({ x: x, y: y });
                this.csvData.xyBattery.push([x, y]);
            }
            //---------------------------------
            for (let i in this.dbCmd04Logs) {
                let x = this.dbCmd04Logs[i]["send_at"];
                x = this.$moment(x).format("YYYY-MM-DD HH:mm:ss");
                //----------
                let y = this.dbCmd04Logs[i]["water"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xyWater.push({ x: x, y: y });
                let _water = y;
                //----------
                y = this.dbCmd04Logs[i]["temp"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xyTemp.push({ x: x, y: y });
                let _temp = y;
                this.csvData.xyWaterTemp.push([x, _water, _temp]);
                //----------
                y = this.dbCmd04Logs[i]["solar"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xySolar.push({ x: x, y: y });
                this.csvData.xySolar.push([x, y]);
                //----------
                y = this.dbCmd04Logs[i]["oxygen"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xyOxygen.push({ x: x, y: y });
                this.csvData.xyOxygen.push([x, y]);
                //----------
                y = this.dbCmd04Logs[i]["salinity"];
                if (y != null && !isNaN(y)) y = Number(y);
                this.dbData.xySalinity.push({ x: x, y: y });
                this.csvData.xySalinity.push([x, y]);
            }
            //---------------------------------
            this.dbData.xyFeed.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xyReact.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xyWater.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xyTemp.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xySolar.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xyOxygen.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xySalinity.push(JSON.parse(JSON.stringify(defaultEPoint)));
            this.dbData.xyBattery.push(JSON.parse(JSON.stringify(defaultEPoint)));
            //---------------------------------
            this.dbData.xyFeed = convBarData(this, this.dbData.xyFeed);
            this.dbData.xyReact = convBarData(this, this.dbData.xyReact);
            //---------------------------------
            for (let xy of this.dbData.xyFeed) this.csvData.xyFeed.push([xy.x, xy.y]);
            for (let xy of this.dbData.xyReact) this.csvData.xyReact.push([xy.x, xy.y]);
            //---------------------------------
            function convBarData(pThis, argData) {
                //let stepSec = 60 * 60 * 1; // 累計のまとめ時間(1時間)
                let stepSec = 60 * 10; // 累計のまとめ時間(10分間)
                const utcDiff = 60 * 60 * 9; // UTCとJSTの時差 +9時間
                let step1Data = [];
                let step2Data = [];
                //------------- step1 時刻の端数切り --------------
                // if (pThis.daySpanValue == 1) stepSec = 60 * 30;
                // if (pThis.daySpanValue >= 2) stepSec = 60 * 60;
                // if (pThis.daySpanValue >= 7) stepSec = 60 * 60 * 6;
                // if (pThis.daySpanValue >= 14) stepSec = 60 * 60 * 12;
                // if (pThis.daySpanValue >= 30) stepSec = 60 * 60 * 24;
                for (let obj of argData) {
                    let unixTIme = pThis.$moment(obj.x).unix();
                    unixTIme = unixTIme + utcDiff;
                    unixTIme = Math.floor(unixTIme / stepSec) * stepSec;
                    unixTIme = unixTIme - utcDiff;
                    let x = pThis.$moment(unixTIme, "X").format("YYYY-MM-DD HH:mm");
                    step1Data.push({ x: x, y: obj.y });
                }
                //--- step2 端数切りした結果、時刻が同じ場合はまとめる -----
                for (let fst of step1Data) {
                    let searchFlg = false;
                    for (let snd of step2Data) {
                        if (snd.x == fst.x) {
                            searchFlg = true;
                            snd.y = snd.y + fst.y;
                        }
                    }
                    if (searchFlg == false) {
                        step2Data.push({ x: fst.x, y: fst.y });
                    }
                }
                return step2Data;
            }
            //---------------------------------
        },
        //====================================================
        registChartData() {
            //----------------------
            this.chartDataSetFeed = { datasets: [] };
            this.chartDataSetFeed.datasets.push({
                label: "給餌量(kg)",
                data: this.dbData.xyFeed,
                borderColor: this.chartColor.feed,
                backgroundColor: this.chartColor.feed,
                borderWidth: 2,
                fill: true,
                //barPercentage: 1.2,
                //categoryPercentage: 1.0,
            });
            //----------------------
            this.chartDataSetReact = { datasets: [] };
            this.chartDataSetReact.datasets.push({
                label: "自発回数",
                data: this.dbData.xyReact,
                borderColor: this.chartColor.react,
                backgroundColor: this.chartColor.react,
                borderWidth: 2,
                fill: true,
                //barPercentage: 1.2,
                //categoryPercentage: 1.0,
            });
            //----------------------
            this.chartDataSetTemp = { datasets: [] };
            this.chartDataSetTemp.datasets.push({
                label: "水温",
                data: this.dbData.xyWater,
                borderColor: this.chartColor.water,
                borderWidth: 2,
                fill: false,
            });
            this.chartDataSetTemp.datasets.push({
                label: "気温",
                data: this.dbData.xyTemp,
                borderColor: this.chartColor.temp,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
            this.chartDataSetSolar = { datasets: [] };
            this.chartDataSetSolar.datasets.push({
                label: "日射量",
                data: this.dbData.xySolar,
                borderColor: this.chartColor.solar,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
            this.chartDataSetOxygen = { datasets: [] };
            this.chartDataSetOxygen.datasets.push({
                label: "溶存酸素",
                data: this.dbData.xyOxygen,
                borderColor: this.chartColor.oxygen,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
            this.chartDataSetSalinity = { datasets: [] };
            this.chartDataSetSalinity.datasets.push({
                label: "塩分濃度",
                data: this.dbData.xySalinity,
                borderColor: this.chartColor.salinity,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
            this.chartDataSetBattery = { datasets: [] };
            this.chartDataSetBattery.datasets.push({
                label: "バッテリー",
                data: this.dbData.xyBattery,
                borderColor: this.chartColor.battery,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
        },
        //====================================================
        downloadCSV(data) {
            let deviceName = this.dbDevice.name;
            let mergeAry = data;
            self.console.log(data);
            //----------------------------------------------------------------
            //  配列をCSV化
            //----------------------------------------------------------------
            let csv = "\ufeff" + deviceName + "\n";
            for (let i in mergeAry) {
                csv += mergeAry[i].join(",") + "\n";
            }
            let blob = new Blob([csv], { type: "text/csv" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "sfs.csv";
            document.body.appendChild(link);
            link.click();
        },
        //====================================================
    },
};
</script>
